/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */
/* eslint-disable max-len */

import { MouseEvent } from 'react';

import ExecutionCardDetails from './ExecutionCardDetails';

import { RunExecution, RunExecutionDetails } from '@/commons/protocols';
import { cn } from '@/utils';

type ExecutionCardProps = {
    execution?: RunExecutionDetails;
    displayLoading: boolean;
    projectSlug?: string;
    suiteSlug?: string;
    defaultOpen?: boolean;
    socketCancelRun?: () => void;
    filterCrash?: boolean;
    handleArchive?: (id: number) => void;
    handleRun?: (id: number) => void;
    selectedRuns?: { runId: number; executionId: number; storyId?: number }[];
    setSelectedRun?: (run: { runId: number; executionId: number }) => void; // Keep for backward compatibility
    onSelectRun?: (run: RunExecution, event: MouseEvent<HTMLButtonElement>) => void;
    openStepViewer?: () => void;
};

const ExecutionCard = ({
    execution,
    displayLoading,
    projectSlug,
    suiteSlug,
    socketCancelRun,
    handleArchive,
    handleRun,
    selectedRuns = [],
    setSelectedRun,
    onSelectRun,
    openStepViewer,
}: ExecutionCardProps) => {
    return (
        <div className={cn('flex flex-col')}>
            {displayLoading || execution === undefined ? (
                <>
                    <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-24 mb-4" />
                    <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-4" />
                    <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-4" />
                    <span className="sr-only">Loading...</span>
                </>
            ) : (
                <div className="flex flex-col w-full">
                    {execution && handleArchive && (
                        <ExecutionCardDetails
                            execution={execution}
                            projectSlug={projectSlug}
                            suiteSlug={suiteSlug}
                            executionId={execution.id.toString()}
                            socketCancelRun={socketCancelRun}
                            handleArchive={handleArchive}
                            handleRun={handleRun}
                            selectedRuns={selectedRuns}
                            onSelectRun={onSelectRun}
                            openStepViewer={openStepViewer}
                            // For backward compatibility
                            selectedRun={selectedRuns.length === 1 ? selectedRuns[0] : undefined}
                            setSelectedRun={setSelectedRun}
                        />
                    )}
                </div>
            )}
        </div>
    );
};

export default ExecutionCard;
